
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://rycfesfsxjvwqcamlqoy.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ5Y2Zlc2ZzeGp2d3FjYW1scW95Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk5MTkwNjksImV4cCI6MjA2NTQ5NTA2OX0.CGnB7640xqXdUd83ifF9kLb18A63hwFreysMYojlzTg'

export const supabase = createClient(supabaseUrl, supabaseKey)
